<template>
  <div>
    <PCNavbar selectIndex="20"/>
    <MobileNavBar :currentActive="19" />
    <capacityBuildingCategory/>
    <router-view></router-view>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import capacityBuildingCategory from '@/components/service_capacity_building_category-9/index.vue'
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    capacityBuildingCategory
  },
}
</script>

<style>
.el-timeline-item__timestamp{
  font-size: 0.9rem !important;
  padding: 1rem 0;
}
</style>